import GoogleMapsLoader from 'google-maps';
import {searchCriteriaMixin} from "./searchCriteriaMixin.js";

export const searchBoxMixinV2 = {
	data() {
		return {
			autocomplete: null,
		};
	},
	watch: {
		'searchCriteria.addressName': {
			handler(newVal, oldVal) {
				//console.log("Address name has been updated: ", {newVal, oldVal});
				$(this.$refs.autocompleteRef).val(newVal || '');
			},
			immediate: true
		}
	},
	mixins: [searchCriteriaMixin],
	methods: {
		async baseInit() {
			this.createAddressAutocomplete();
			await this.setCurrentCriteria();
		},
		createAddressAutocomplete() {
			GoogleMapsLoader.KEY = 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM';
			GoogleMapsLoader.LIBRARIES = ['places'];
			GoogleMapsLoader.VERSION = '';
			let self = this;
			GoogleMapsLoader.load(function (google) {
				self.widgetReady = true;
				self.$nextTick(function () {
					//console.log('self.$refs:', self.$refs, 'autocomplete:', self.$refs.autocompleteRef);
					self.autocomplete = new google.maps.places.Autocomplete(
						self.$refs.autocompleteRef,
						{types: ['geocode']}
					);
					self.autocomplete.addListener('place_changed', self.autocompleteCallback);
				});
			});
		},
		autocompleteCallback() {
			let place = this.autocomplete.getPlace();
			this.searchCriteria.latitude = place.geometry.location.lat();
			this.searchCriteria.longitude = place.geometry.location.lng();
			this.searchCriteria.addressName = $(this.$refs.autocompleteRef).val();
		},
	}
};